import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import robotoRegular from "../assets/Roboto-Regular.ttf";
import robotoBold from "../assets/Roboto-Bold.ttf";
import robotoItalic from "../assets/Roboto-Italic.ttf";
import robotoBoldItalic from "../assets/Roboto-BoldItalic.ttf";
import dayjs from "dayjs";

Font.register({
  family: "Roboto",
  fonts: [
    { src: robotoRegular },
    { src: robotoBold, fontWeight: "bold" },
    { src: robotoItalic, fontStyle: "italic" },
    { src: robotoBoldItalic, fontWeight: "bold", fontStyle: "italic" },
  ],
});

const styles = StyleSheet.create({
  page: {
    padding: 40,
    alignItems: "center",
    flexDirection: "column",
    fontFamily: "Roboto",
  },
  header: {
    fontSize: 20,
    marginTop: 5,
    marginBottom: 15,
  },
  logo: {
    position: "absolute",
    top: 40,
    left: 40,
    height: 36,
    width: 60,
  },
  sectionTitle: {
    width: "100%",
    textAlign: "left",
    paddingHorizontal: 5,
    paddingVertical: 2,
    marginBottom: 5,
    fontSize: 10,
    fontWeight: "bold",
    backgroundColor: "#8AC2EA",
  },
  section: {
    flexDirection: "column",
    marginBottom: 20,
    gap: 5,
    fontSize: 10,
  },
  row: {
    flexDirection: "row",
  },
  spaceBetween: {
    justifyContent: "space-between",
  },
  fieldName: {
    width: "30%",
    paddingLeft: 5,
    paddingRight: 20,
  },
  fieldContent: {
    width: "70%",
    paddingRight: 5,
    fontWeight: "bold",
  },
  fieldContentAlt: {
    width: "70%",
    paddingRight: 5,
  },
  font: {
    fontSize: 10,
  },
  footer: {
    position: "absolute",
    bottom: 10,
    left: 40,
    right: 40,
    paddingTop: 1,
    borderTopWidth: 0.5,
    borderColor: "#000000",
    flexDirection: "column",
    textAlign: "left",
    fontSize: 10,
  },
});

export const FormPdfView = ({ ...props }) => {
  const {submissionForm} = props;
  return (
    <Document>
      <Page
        style={styles.page}
        size="A4"
      >
        <Text style={styles.header}>Dane deklaracji elektronicznej</Text>
        <Text style={styles.sectionTitle}>Dane deklaracji</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Nazwa organu: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.authorityName}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Data złożenia deklaracji: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.declarationDate ? dayjs(submissionForm.declarationDate).format('DD.MM.YYYY') : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Województwo: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.voivodeship}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Liczba oddziałów: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.branchCount}
            </Text>
          </View>
        </View>
        <Text style={styles.sectionTitle}>Dane podmiotu</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Nazwa podmiotu: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.name}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>REGON: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.regon}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>KRS: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.krs}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Strona WWW: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.website}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Kategorie/podkategorie: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.category}
            </Text>
          </View>
        </View>
        <Text style={styles.sectionTitle}>Inne dane</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Zasięg terytorialny: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.territorialRange}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Wielkość uprawnienia w %: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.privilegePercent ? submissionForm.privilegePercent : ""}
            </Text>
          </View>
        </View>
        <Text style={styles.sectionTitle}>Dane adresowe</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Województwo: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.voivodeship}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Powiat: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.district}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Gmina: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.commune}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Miejscowość: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.city}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Ulica: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.street ? submissionForm.street : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Numer budynku: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.buildingNumber}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Numer lokalu: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.apartmentNumber ? submissionForm.apartmentNumber : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Kod pocztowy: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.zipcode}
            </Text>
          </View>
        </View>
        <Text style={styles.sectionTitle}>Dane przedstawiciela</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Nazwisko przedstawiciela: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.lastName ? submissionForm.lastName : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Imię przedstawiciela: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.firstName ? submissionForm.firstName : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Telefon przedstawiciela: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.phoneNumber}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>E-mail przedstawiciela: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.email ? submissionForm.email : ""}
            </Text>
          </View>
        </View>
        <Text style={styles.sectionTitle}>Dane ulgi</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Opis uprawnienia: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.privilegeDescription}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Okres obow. ulgi od: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.validityStart ? dayjs(submissionForm.validityStart).format('DD.MM.YYYY') : ""}
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.fieldName}>Okres obow. ulgi do: </Text>
            <Text style={styles.fieldContent}>
              {submissionForm.validityEnd ? dayjs(submissionForm.validityEnd).format('DD.MM.YYYY') : ""}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};
